import React, { useState, useEffect } from 'react';
import FormControl from '@material-ui/core/FormControl';
import FormHelperText from '@material-ui/core/FormHelperText';
import { Select } from '@backstage/core-components';
import { useScaffolder } from '../../hooks/useScaffolder.esm.js';
import { Grid, InputLabel, Input } from '@material-ui/core';
import { ProviderService } from '../../services/ProviderService.esm.js';

const GitlabRepoPicker = (props) => {
  const { allowedOwners = [], rawErrors, state, onChange, hosts } = props;
  const ownerItems = allowedOwners ? allowedOwners.map((i) => ({ label: i, value: i })) : [{ label: "Loading...", value: "loading" }];
  const { owner } = state;
  const [items, setItems] = useState();
  const [ownerList, setOwnerList] = useState();
  const { gitlabScaffolderExists, gitlabTokenScaffolder, gitlabHostScaffolder } = useScaffolder();
  const messageLoading = "loading ...";
  const itemsList = (data) => {
    if (data !== void 0) {
      const owners = [];
      data.forEach((item) => {
        owners.push({
          label: item,
          value: item
        });
      });
      return owners;
    }
    return [{
      label: messageLoading,
      value: messageLoading
    }];
  };
  const fetchData = async () => {
    const getData = new ProviderService("gitlab", gitlabHostScaffolder, gitlabTokenScaffolder).getUserAndOrgs();
    try {
      const user = (await getData).username;
      const organizations = (await getData).organizations;
      if (user !== "Not found") {
        const ownerDataResult = [user, ...organizations];
        setItems(ownerDataResult);
      } else {
        const ownerDataResult = ["Not Found"];
        setItems(ownerDataResult);
      }
    } catch (err) {
      throw new Error(err);
    }
  };
  useEffect(() => {
    if (!hosts?.includes("gitlab") || gitlabScaffolderExists) {
      fetchData();
    }
  }, []);
  useEffect(() => {
    if (items) {
      const data = itemsList(items);
      setOwnerList(data !== void 0 ? data : [{ label: messageLoading, value: messageLoading }]);
      if (!owner) {
        onChange({ owner: items[0] });
      }
    }
  }, [items]);
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(
    FormControl,
    {
      margin: "normal",
      required: true,
      error: rawErrors?.length > 0 && !owner
    },
    gitlabScaffolderExists ? /* @__PURE__ */ React.createElement(React.Fragment, null, allowedOwners?.length ? /* @__PURE__ */ React.createElement(
      Select,
      {
        native: true,
        label: "Owner Available",
        onChange: (s) => onChange({ owner: String(Array.isArray(s) ? s[0] : s) }),
        disabled: allowedOwners.length === 1,
        selected: owner,
        items: ownerItems
      }
    ) : /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(Grid, { item: true, style: { marginBottom: "1rem" } }, /* @__PURE__ */ React.createElement(
      Select,
      {
        native: true,
        label: "Owner",
        onChange: (s) => onChange({ owner: String(Array.isArray(s) ? s[0] : s) }),
        disabled: allowedOwners.length === 1,
        selected: owner,
        items: ownerList
      }
    )))) : /* @__PURE__ */ React.createElement(React.Fragment, null, allowedOwners?.length ? /* @__PURE__ */ React.createElement(
      Select,
      {
        native: true,
        label: "Owner Available",
        onChange: (selected) => onChange({
          owner: String(Array.isArray(selected) ? selected[0] : selected)
        }),
        disabled: allowedOwners.length === 1,
        selected: owner,
        items: ownerItems
      }
    ) : /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(InputLabel, { htmlFor: "ownerInput" }, "Owner"), /* @__PURE__ */ React.createElement(
      Input,
      {
        id: "ownerInput",
        onChange: (e) => onChange({ owner: e.target.value }),
        value: owner
      }
    ))),
    /* @__PURE__ */ React.createElement(FormHelperText, null, "GitLab namespace where this repository will belong to. It can be the name of organization, group, subgroup, user, or the project.")
  ));
};

export { GitlabRepoPicker };
//# sourceMappingURL=GitlabRepoPicker.esm.js.map
